/**
 * Russian plural-form picker for a count (год/года/лет, отзыв/отзыва/отзывов, день/дня/дней, …).
 * kk/en are not affected — kk has no grammatical number agreement and en's regular "-s" plural
 * needs no lookup table, so this stays a ru-only helper (callers branch on the active language
 * before using it). See history 2026-08-22 retro item #6.
 */
export function pluralRu(n: number, forms: readonly [one: string, few: string, many: string]): string {
  const mod10 = n % 10;
  const mod100 = n % 100;
  if (mod10 === 1 && mod100 !== 11) {
    return forms[0];
  }
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return forms[1];
  }
  return forms[2];
}
